import { render, staticRenderFns } from "./DefaultSlider.vue?vue&type=template&id=98d5412e&scoped=true"
import script from "./DefaultSlider.vue?vue&type=script&lang=js"
export * from "./DefaultSlider.vue?vue&type=script&lang=js"
import style0 from "./DefaultSlider.vue?vue&type=style&index=0&id=98d5412e&prod&lang=scss&scoped=true"
import style1 from "./DefaultSlider.vue?vue&type=style&index=1&id=98d5412e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d5412e",
  null
  
)

export default component.exports